import { Dropdown, message } from '@linktivity/link-ui';
import { ReactComponent as UserIcon } from '@nankai/admin/assets/icons/user.svg';
import { useAuth } from '@nankai/admin/context/AuthContext';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './layoutUser.module.css';

const LayoutUser: React.FC = () => {
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = useState(false);
  const { user, logout } = useAuth();

  const userButton = useMemo(
    () => (
      <button
        className={styles.button}
        type="button"
        onClick={() => setOpenMenu(visible => !visible)}
      >
        <UserIcon className={styles.icon} />
        <span className={styles.text}>{t('common.account')}</span>
      </button>
    ),
    [t]
  );

  const showMessage = useCallback((msg: string) => {
    message.info(msg, 10);
  }, []);

  return (
    <Dropdown
      target={userButton}
      visible={openMenu}
      sameWidth={false}
      placement="bottom-end"
      onClose={() => setOpenMenu(false)}
    >
      <Dropdown.Menu className={styles.dropdownMenu}>
        <Dropdown.Item>
          <button
            className={styles.dropdownButton}
            onClick={() => showMessage(user!.email)}
          >
            <p className={styles.dropdownText}>{user?.email}</p>
          </button>
        </Dropdown.Item>
        <Dropdown.Item>
          <button className={styles.dropdownButton} onClick={logout}>
            {t('common.logout')}
          </button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LayoutUser;
